import React from 'react'
import { useRoutes } from 'lib/hooks'
import { TimerDiffDate } from 'asterX-UI/DataDisplay'
import { formatDateTime } from 'lib/utils'
import { useHomeStore } from 'context/HomeStore'
import { Grid, Card, CardContent, Typography, Button} from '@material-ui/core'
import { Pagination } from 'asterX-UI/Pagination'
import { DOCUMENT_PATH } from 'routes/constants.routes'
import { AsterChip } from 'asterX-UI/Chip'
import { colorStatusesByCode, getStatusText } from 'lib/constants/const'
import { useDocumentCardStyles } from './document.card.styles'

const Cards = ({ item }) => {
  const classes = useDocumentCardStyles()
  const router = useRoutes()
  const {
    homeStore: { selectedTab }
  } = useHomeStore()

  const date = formatDateTime(item?.createdDate)

  const carData = [
    { label: 'Инициатор', value: item?.createdByFullname },
    {
      label: 'Время',
      value: [0].includes(selectedTab) ? <TimerDiffDate date={item?.createdDate} /> : date
    }
  ]

  return (
    <Card className={classes.card}>
      <CardContent style={{ padding: 16, position: 'relative' }}>
        <Grid item container display="flex" xs={12} sm={12} justifyContent="space-between">
          <Grid item>
            <Typography className={classes.title}>{`Заявка №${item?.workListId}`}</Typography>
          </Grid>
          <Grid item>
            <AsterChip
              label={getStatusText(item?.statusTrack?.documentStatus?.code) || '-'}
              style={colorStatusesByCode(item?.statusTrack?.documentStatus?.code)}
            />
          </Grid>
        </Grid>

        <Typography className={classes.subTitle}>{item?.documentType}</Typography>
        {carData.map((item, index) => (
          <Grid
            item
            container
            key={`carData_${index}`}
            display="flex"
            alignItems="center"
            xs={12}
            sm={12}
            md={12}
            style={{ marginBottom: 8 }}
          >
            <Grid item xs={4} sm={4}>
              <Typography className={classes.description}>{item.label}</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Typography className={classes.answer}>{item.value}</Typography>
            </Grid>
          </Grid>
        ))}
        <Grid item container display="flex" justifyContent="space-between" spacing={2} style={{ marginTop: 5 }}>
          <Grid item xs={12} sm={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => router.goTo(`${DOCUMENT_PATH}/${item?.id}`)}
            >
              Подробнее
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

const DocumentCards = () => {
  const classes = useDocumentCardStyles()

  const {
    homeStore: { lists, pagination, isMobile },
    homeStoreFunc: { handlePaginationChange }
  } = useHomeStore()





  return (
    <>
      <Grid container item spacing={6}>
        {(lists || []).map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={`documents_${idx}`}>
            <Cards item={item} />
          </Grid>
        ))}

        <Grid item xs={12}>
          <Pagination
            className={classes.pagination}
            count={Math.ceil(pagination.count)}
            page={pagination.offset ? pagination.offset : 1}
            onChange={handlePaginationChange}
            isMobile={isMobile}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default DocumentCards
